import { toast } from 'react-toastify';

import { formatDatetime } from '../../helpers/timezone';
import { ReactComponent as CopySVG } from '../../icons/copy.svg';

const InvitationsCard = ({ data }) => {
  if (data.length === 0) return null;

  const onClick = (invitation) => {
    navigator.clipboard.writeText(
      `${invitation.domain}/invitation/${invitation.token}`,
    );
    toast('Copied to clipboard');
  };

  return (
    <div className="w-100 flex flex-column items-start justify-between">
      <div className="w-100">
        <section className="apps-grid-container th-active-users">
          <span className="apps-grid-title">Invitations</span>
          <div className="apps-grid">
            {data.map((f) => {
              return (
                <div key={f.id} className="apps-grid-cell">
                  <article className="apps-card-app">
                    <div className="apps-card-left">
                      <div className="apps-card-meta">
                        <h3 className="apps-card-app-title">
                          {`${f.domain}/invitation/${f.token}`}
                        </h3>
                        <p className="apps-card-app-desc">
                          Created at: {formatDatetime(f.createdAt)}
                        </p>
                      </div>
                    </div>
                    <div className="apps-card-right">
                      <div className="mr5 flex">
                        <CopySVG
                          data-rh="Copy"
                          className="h6 w6 pointer"
                          onClick={() => onClick(f)}
                        />
                      </div>
                      <div className="apps-configured">
                        <span className="th-badge">
                          {f.accepted ? 'ACCEPTED' : 'PENDING'}
                        </span>
                      </div>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

export default InvitationsCard;
